import { render, staticRenderFns } from "./TemplatesTable.vue?vue&type=template&id=031f4e40&lang=pug"
import script from "./TemplatesTable.vue?vue&type=script&lang=js"
export * from "./TemplatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports